import { Chip } from "@mui/material"

export function SourceBadgeChip({ item }) {
    return <Chip size="small" label={item || "Recommendation"} color="primary" variant="outlined" />
}
